import React, { createContext, useContext, useState, useEffect } from "react";
import { ref, set, get, child, push } from "firebase/database";
import { database } from "../firebaseConfig";
import { useAuth } from "./auth";

const GuestbookContext = createContext();

export const useGuestbook = () => useContext(GuestbookContext);

export const GuestbookProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEntries = async () => {
      try {
        setLoading(true);
        const dbRef = ref(database, "guestbook");
        const snapshot = await get(dbRef);
        if (snapshot.exists()) {
          setEntries(Object.values(snapshot.val()));
        }
      } catch (error) {
        console.error("Error fetching guestbook entries:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEntries();
  }, []);

  const addEntry = async (text) => {
    if (!currentUser) return;
    if (!text) return;
    try {
      const newEntry = {
        text,
        user: currentUser.data.displayName,
        timestamp: new Date().toISOString(),
      };
      const newEntryRef = push(ref(database, "guestbook"));
      await set(newEntryRef, newEntry);
      setEntries((prevEntries) => [...prevEntries, newEntry]);
    } catch (error) {
      console.error("Error adding guestbook entry:", error);
    }
  };

  const value = {
    entries,
    addEntry,
    loading,
  };

  return (
    <GuestbookContext.Provider value={value}>
      {!loading && children}
    </GuestbookContext.Provider>
  );
};
